import React from 'react';

const EmailOutboxIcon = (props) => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='currentColor'>
        <path d='M13 13a1 1 0 0 1 .117 1.993L13 15H9.618l-1.416 2.781 4.098.003a.908.908 0 0 1 .858.61l.065.251.042.14.061.175c.264.691.97 1.91 2.674 1.91 1.491 0 2.219-.934 2.554-1.633l.09-.2.036-.094.059-.167.04-.136.032-.13a.91.91 0 0 1 .767-.717l.124-.009 4.07-.003L22.382 15H19l-.117-.007a1 1 0 0 1 0-1.986L19 13h4l.125.008a1 1 0 0 1 .706.437l.063.108 2 4 .046.107c.04.109.06.22.06.332v4.445a2.273 2.273 0 0 1-2.073 2.264l-.2.009H8.273a2.273 2.273 0 0 1-2.264-2.073l-.01-.2v-4.445c.002-.111.021-.223.06-.332l.047-.107 2-4a1 1 0 0 1 .77-.545L9 13h4zm3-7 .086.004.132.02.115.033.125.054.107.064.077.058 3.509 3.008.09.087a1 1 0 0 1-1.291 1.507l-.1-.076L17 9.175V17l-.007.117a1 1 0 0 1-1.986 0L15 17V9.174l-1.85 1.585-.1.076a1 1 0 0 1-1.291-1.507l.09-.087 3.5-3 .062-.05.095-.06.096-.049.082-.031.184-.042.066-.007L16 6z' />
      </g>
    </svg>
  );
};

export default EmailOutboxIcon;
